export default __webpack_public_path__ + "static/media/FuturaStd-Book.07386c9f.woff2";